import * as Icon from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";

export function PFModal(props) {
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    async function setFlag(color) {

        props.order.f_color = color;

        try {
            await axios.get(
                APIBASE + 'api/bestellungen/setFlag/' + props.order.p_id + '/' + color, {headers: header}
            );

        } catch (err) {
            console.log(err.message || 'Something went wrong!');
        }
    };




    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Belegnummer: {props.order.p_documentNo}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul>
                    <li>Artikelnummer: {props.order.p_no} {props.order.p_variantCode} {props.order.p_LineNo}
                    </li>
                    <li>GTIN-Verkaufseinheit: {(props.order.p_VariantGTINSalesUnit !== 0) ? props.order.p_VariantGTINSalesUnit : props.order.p_VariantGTINSalesUnit}
                    </li>
                    <li>GTIN-Kolli: {(props.order.p_VariantGTINColli !== 0) ? props.order.p_VariantGTINColli : props.order.p_VariantGTINColli}
                    </li>
                    {props.order.salesContact && <li>angelegt/geändert
                        von {props.order.salesContact.firstName} {props.order.salesContact.lastName}
                        <ul>
                            {props.order.salesContact.phoneNo && <li>{props.order.salesContact.phoneNo}</li>}
                            {props.order.salesContact.eMail && <li><a
                                href={`mailto:${props.order.salesContact.eMail}`}>{props.order.salesContact.eMail}</a>
                            </li>}
                        </ul>
                    </li>}
                </ul>
                {props.order.p_Lieferzeit && props.order.p_Lieferzeit !== '00:00' &&
                    <p className="fg-magenta">Bis {props.order.p_Lieferzeit}</p>}
                <p className="fg-magenta">
                    {props.order.p_Notice}
                </p>
                <p className="fg-magenta">
                    {props.order.p_servedByIcRemark}
                </p>
                <div className="row">
                    <div className="col-md-6">
                        {props.filenotfound && <span className="badge text-bg-danger">Datei nicht gefunden.</span>}
                        <button type="button" className="btn btn-info" onClick={() => {
                            props.fetchpalettenbs(props.order.p_documentNo, props.order.p_LineNo, true)
                        }}>Palettenbegleitschein
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">Markierung hinzufügen</div>
                </div>
                <div className="row">
                    <div className="col-1" onClick={() => setFlag('yellow')}>
                        <Icon.FlagFill color="yellow"/>
                    </div>
                    <div className="col-1" onClick={() => setFlag('violet')}>
                        <Icon.FlagFill color="violet"/>
                    </div>
                    <div className="col-1" onClick={() => setFlag('royalBlue')}>
                        <Icon.FlagFill color="royalBlue"/>
                    </div>
                    <div className="col-1" onClick={() => setFlag('mediumSeaGreen')}>
                        <Icon.FlagFill color="mediumSeaGreen"/>
                    </div>
                    <div className="col-1" onClick={() => setFlag('red')}>
                        <Icon.FlagFill color="red"/>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
